/**
 * @generated SignedSource<<23bd399b659545ef34acefd98d9f8417>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OrderApp_charge$data = {
  readonly correlationID: string | null | undefined;
  readonly id: string;
  readonly metaPixel: {
    readonly token: string | null | undefined;
  } | null | undefined;
  readonly redirectUrl: string | null | undefined;
  readonly status: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"Order_charge" | "useMeta_charge">;
  readonly " $fragmentType": "OrderApp_charge";
};
export type OrderApp_charge$key = {
  readonly " $data"?: OrderApp_charge$data;
  readonly " $fragmentSpreads": FragmentRefs<"OrderApp_charge">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "concreteType": "IntegrationMetaPixel",
  "kind": "LinkedField",
  "name": "metaPixel",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "token",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OrderApp_charge",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Order_charge"
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "useMeta_charge",
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "value",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "identifier",
          "storageKey": null
        },
        (v1/*: any*/)
      ],
      "args": null,
      "argumentDefinitions": []
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "redirectUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "correlationID",
      "storageKey": null
    },
    (v1/*: any*/)
  ],
  "type": "Charge",
  "abstractKey": null
};
})();

(node as any).hash = "df35cccf9a1348ccb94b68b8f062d619";

export default node;
